import { appSettingsRepository } from '../infrastructure/appSettings.repository';

export function getThemePrimaryColor(): Promise<string | undefined> {
  return appSettingsRepository.getThemeColor();
}

export function updateThemePrimaryColor(value: string): Promise<void> {
  return appSettingsRepository.updateThemeColor(value);
}